// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__F9Avs","bigColWidth":"Table_bigColWidth__2uT7o","biggerColWidth":"Table_biggerColWidth__2EW_v","row":"Table_row__1lmlD","col":"Table_col__1GmfK"};